export var colors = {
  primary: '#6C5DD3',
  primaryHover: '#4535B7',
  foreground: '#11142D',
  accent9: '#808191',
  accent8: '#9395A1',
  accent7: '#B2B3BD',
  accent6: '#D3D4DD',
  accent3: '#D5D5E7',
  accent2: '#EEEEF8',
  accent1: '#F7F7FD',
  background: '#FFFFFF',
  error: '#FF754C',
  warning: '#FFCE73',
  success: '#7FBA7A'
};
export var elevation = {
  0: '0',
  1: '0px 3px 6px rgba(0, 0, 0, 0.04), 0px 1px 2px rgba(0, 0, 0, 0.02);',
  2: '0px 1px 2px rgba(0, 0, 0, 0.02), 0px 3px 7px rgba(0, 0, 0, 0.03), 0px 12px 31px rgba(0, 0, 0, 0.05);'
};
export var fontFamilies = {
  inter: 'Inter',
  poppins: 'Poppins'
};
export var fontSizes = {
  body: 14,
  label: 13,
  buttonLabel: 14,
  tooltipLabel: 13,
  h3: 16,
  h2: 18,
  h1: 21
};
export var fontWeights = {
  body: 300,
  label: 300,
  buttonLabel: 600,
  tooltipLabel: 400,
  h3: 600,
  h2: 500,
  h1: 600
};
export var lineHeights = {
  body: 1.75,
  label: 1.2,
  buttonLabel: 1.4,
  tooltipLabel: 1.2,
  h3: 1.3,
  h2: 1.3,
  h1: 1.3
}; // font: font-style font-variant font-weight font-size/line-height font-family;

export var fonts = {
  body: "".concat(fontSizes.body, "/").concat(lineHeights.body, " ").concat(fontFamilies.inter, ", sans-serif"),
  label: "".concat(fontSizes.label, "/").concat(lineHeights.label, " ").concat(fontFamilies.inter, ", sans-serif"),
  buttonLabel: "".concat(fontSizes.buttonLabel, "/").concat(lineHeights.buttonLabel, " ").concat(fontFamilies.inter, ", sans-serif"),
  tooltipLabel: "".concat(fontSizes.tooltipLabel, "/").concat(lineHeights.tooltipLabel, " ").concat(fontFamilies.inter, ", sans-serif"),
  h3: "".concat(fontSizes.h3, "/").concat(lineHeights.h3, " ").concat(fontFamilies.inter, ", sans-serif"),
  h2: "".concat(fontSizes.h2, "/").concat(lineHeights.h2, " ").concat(fontFamilies.poppins, ", sans-serif"),
  h1: "".concat(fontSizes.h2, "/").concat(lineHeights.h2, " ").concat(fontFamilies.poppins, ", sans-serif")
};
var tokens = {
  colors: colors,
  elevation: elevation,
  fontSizes: fontSizes,
  fontWeights: fontWeights,
  lineHeights: lineHeights,
  fonts: fonts,
  fontFamilies: fontFamilies
};
export default tokens;